import { Route } from 'react-router-dom';
import { Redirect, Switch, useLocation, useParams, useRouteMatch } from 'react-router';
import { LOANFORMAT_EPRESS_OBJECT } from '../../store/loanFormat/actions';
import { CataloguePage } from './CataloguePage';
import { GenreEntryPage } from '../entrypages/genre/GenreEntryPage';
import { PublisherEntryPage } from '../entrypages/publishers/PublisherEntryPage';
import { NewReleasesEntryPage } from '../entrypages/newReleases/NewReleasesEntryPage';
import { FeaturedEntryPage } from '../entrypages/featured/FeaturedEntryPage';
import { PageNotFound } from '../PageNotFound';
import { BundlesOverviewPage } from '../../shared/bundles/BundlesOverviewPage';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';
import { ProductTypePage } from '../product-type/ProductTypePage';
import { CheckLoanFormatAndProductType } from '../product-type/CheckLoanFormatAndProductType';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { FC } from 'react';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';

export const CatalogueTemplate: FC = () => {
    const { path, url } = useRouteMatch();
    const { pathname, search } = useLocation();
    const { loanFormat, shopLanguage } = useParams<{ loanFormat: string; shopLanguage?: string }>();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    if (isMultiLanguageShopEnabled && !shopLanguage) {
        const redirectPath = pathname.replace('/catalogue', `/shop/en`);

        return <Redirect to={{ pathname: redirectPath, search }} />;
    }

    return (
        <Switch>
            <Route path={`${path}/featured`}>
                <FeaturedEntryPage />
            </Route>
            <Route exact path={path}>
                <Redirect to={{ pathname: `${url}/featured`, search: searchParams.toString() }} />
            </Route>
            <Route path={`${path}/bundles`}>
                <BundlesOverviewPage />
            </Route>
            {loanFormat === LOANFORMAT_EPRESS_OBJECT.urlKey ? (
                <Route path={`${path}/newreleases`}>
                    <Redirect to={`${url}/featured`} />
                </Route>
            ) : null}
            <Route path={`${path}/newreleases`}>
                <NewReleasesEntryPage />
            </Route>
            <Route path={`${path}/products`}>
                <ProductSelectionProvider>
                    <CataloguePage />
                </ProductSelectionProvider>
            </Route>
            <Route path={`${path}/genres/:genre?/:subGenre?`}>
                <GenreEntryPage />
            </Route>
            <Route path={`${path}/publishers/:item?/:subItem?`}>
                <PublisherEntryPage />
            </Route>
            <Route path={`${path}/:productType`}>
                <CheckLoanFormatAndProductType>
                    {({ loanFormat, productType }) => (
                        <ProductSelectionProvider>
                            <ProductTypePage loanFormat={loanFormat} productType={productType} />
                        </ProductSelectionProvider>
                    )}
                </CheckLoanFormatAndProductType>
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};
